$(document).ready(function() {
  
  var date = new Date();
  var hours = (date.getHours() < 10 ? '0' : '') + 
      date.getHours();
  var minutes = (date.getMinutes() < 10 ? '0' : '') + 
      date.getMinutes();
  var current_time =  hours + ":" + minutes ;
  
  //get day
  var day = date.getDay();
  var daylist = ["Sunday","Monday","Tuesday","Wednesday ","Thursday","Friday","Saturday"];
  
  
  if(daylist[day] == "Monday")
  {
    $('#show_message_shipment').append("<i>For Local delivery</i>, please note that we deliver on only Monday, Wednesday and Friday.");
    
  }
  else
  {
    if(current_time < "24:00" && current_time < "16:00")
    {
      $('#show_message_shipment').append("<i>For Local delivery</i>, please note that we deliver on only <b>Monday, Wednesday and Friday.</b>");
    }
    else if(current_time > "16:00"){
      $('#show_message_shipment').append("<i>For Local delivery</i>, please note that we deliver on only Monday, Wednesday and Friday.");
    }
  }
 
  if(daylist[day] == "Sunday" || daylist[day] == "Saturday" || daylist[day] == "Monday" )
  {
    $('#show_message').append("<i>For shipment</i>, this order will be shipped on Tuesday.");
    
  }
  else
  {
    if(current_time < "24:00" && current_time < "16:00")
    {
      $('#show_message').append("<i>For shipment</i>, order before 16:00 to get the order <a href='https://dbanyan.nl/apps/help-center#hc-what-is-the-delivery-time-for-shipment' class='green-text' target='_blank'>shipped</a> today.");
    }
    else if(current_time > "16:00" && daylist[day] == "Friday"){
      $('#show_message').append("<i>For shipment</i>, order will be <a href='https://dbanyan.nl/apps/help-center#hc-what-is-the-delivery-time-for-shipment' class='green-text' target='_blank'>shipped</a> on Tuesday");
    }
     else if(current_time > "16:00"){
      $('#show_message').append("<i>For shipment</i>, order will be <a href='https://dbanyan.nl/apps/help-center#hc-what-is-the-delivery-time-for-shipment' class='green-text' target='_blank'>shipped</a> tomorrow");
    }
  }
  
});

